import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { approveRejectContactFarmingAgreement, getCFStampDOC, submitContractFarmingFilesAgreement } from "../../../auth/services/privateapicalling";
import { getAggreementFormReview } from "../../../auth/services/apiCalling";
import { toast, ToastContainer } from "react-toastify";
import CertificateMD from "./components/CertificateMD"

const PDFView = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const token = useSelector((state: any) => state.auth.token);
    const [DocId, setDocId] = useState("")
    const userDetail = useSelector((state: any) => state.auth.userDetails);
    const roleIdentifier = userDetail?.Role?.Role_Identifier;
    const [appData, setAppData] = useState(null)
    const location = useLocation()
    const applicationId = location?.state?.Sponsor_Id
    const [comment, setComment] = useState("")
    const [appComment, setAppComment] = useState("")
    const [uploadLoading, setUploadLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        rejectionFile: null as any,
    });
    const [newlyUploaded, setNewlyUploaded] = useState({ rejectionFile: null });
    const [pendingButtonData, setPendingButtonData] = useState(null);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [showRejectSuccessModal, setShowRejectSuccessModal] = useState(false);
    const navigate = useNavigate();

    const formReviewDetails = async () => {
        const resp = await getAggreementFormReview(token, applicationId);
        if (resp?.success == true) {
            setAppData(resp?.data)
            setDocId(resp?.data?.forwardToSpoAfterApprovalResubmissionn?.resubmittedFields?.reg?.currValue?.stampDoc?.data?.docId
                || resp?.data?.forwardToSponsorAterApproval?.resubmittedFields?.reg?.currValue?.stampDoc?.data?.docId)

            setAppComment(resp?.data?.forwardToMBAAfterApprovalResubmissionn?.comment || resp?.data?.forwardToMBAAterApproval?.comment)

        } else {
            toast.error(resp?.message, { position: "top-right" });
        }
    }

    useEffect(() => {
        formReviewDetails();
    }, [applicationId])

    useEffect(() => {
        const loadFile = async () => {
            if (!DocId) return;

            setFile(null);
            setLoading(true);

            try {
                const response = await getCFStampDOC(DocId, token);
              

                if (response.success && response.attachments) {
                    const [key] = Object.keys(response.attachments);
                    const attachment = response.attachments[key];

                    setFile({
                        fileData: attachment.base64,
                        mimeType: attachment.contentType,
                        fileName: key,
                    });
                } else {
                    setFile(null);
                }
            } catch (error) {
               
                setFile(null);
            }

            setLoading(false);
        };

        loadFile();
    }, [DocId, token]);

    // File upload handler
    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        fieldName: string
    ) => {
        const { files } = e.target;
        if (files && files.length > 0) {
            const file = files[0];
            const fileName = file.name;
            handleUpload(fileName, file, fieldName, formData[fieldName]?.docId);
        }
    };

    const handleUpload = async (
        documentName: string,
        file: any,
        fieldName: string,
        docId?: string | null
    ) => {
        if (!applicationId) {
            toast.error("Application ID is missing. Please reload the page.", {
                position: "top-right"
            });
            return;
        }

        const uploadFormData = new FormData();
        uploadFormData.append("file", file);
        uploadFormData.append("documentName", fieldName);
        uploadFormData.append("fieldName", fieldName);
        uploadFormData.append("applicationId", String(applicationId));

        try {
            setUploadLoading(true);
            const res = await submitContractFarmingFilesAgreement(uploadFormData, token, docId);

            if (res.success == false) {
                toast.error(res?.message, { position: "top-right" });
            } else if (res.success && res.docId) {
                setFormData((prev) => ({
                    ...prev,
                    [fieldName]: {
                        docId: res.docId,
                        documentName: fieldName,
                        fileName: documentName,
                    },
                }));

                setNewlyUploaded((prev) => ({
                    ...prev,
                    [fieldName]: {
                        fileName: documentName,
                    },
                }));

                toast.success(res?.message || "File uploaded successfully", {
                    position: "top-right"
                });
            }
        } catch (error) {
           
            toast.error("File upload failed", { position: "top-right" });
        } finally {
            setUploadLoading(false);
        }
    };

    // Universal handler for all button actions
    const handleForward = async (buttonData: any) => {
        // For permanentReject, open modal instead of direct forward
        if (buttonData?.status === "permanentReject") {
            setPendingButtonData(buttonData);
            setShowRejectModal(true);
            return;
        }

        // For other statuses, proceed with normal flow
        if (comment === "") {
            toast.error("Please Enter the comment first", {
                position: "top-right"
            });
            return;
        }

        try {
            const payload: any = {
                applicationId: applicationId,
                status: buttonData?.status,
                appStatusLevel: buttonData?.appStatusLevel,
                comment: comment,
                submittedFields: {},
            };

         

            const res = await approveRejectContactFarmingAgreement(payload, token);

            if (res?.success === true) {
                toast.success("Application Forwarded Successfully", {
                    position: "top-right"
                });
                setTimeout(() => {
                    navigate("/marketing-board-agr-menu")
                }, 1000)
            } else {
                toast.error(res?.message || "Operation failed", {
                    position: "top-right",
                    toastId: 'operation-error'
                });
            }
        } catch (error) {
            
            toast.error("Operation failed", { position: "top-right" });
        }
    };

    // Handle permanent rejection with file
    const handlePermanentReject = async () => {
        if (comment.trim() === '') {
            toast.error("Please enter your remarks", {
                position: "top-right"
            });
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const submittedFields = formData.rejectionFile?.docId ? {
                reg: {
                    rejectionFile: {
                        data: {
                            docId: formData.rejectionFile.docId,
                            documentName: formData.rejectionFile.documentName
                        }
                    }
                }
            } : {};

            const payload: any = {
                applicationId: applicationId,
                status: pendingButtonData?.status,
                appStatusLevel: pendingButtonData?.appStatusLevel,
                comment: comment,
                submittedFields: submittedFields,
            };


            const res = await approveRejectContactFarmingAgreement(payload, token);

            if (res?.success === true) {
                setShowRejectModal(false);
                setShowRejectSuccessModal(true);
                toast.success("Application Rejected Successfully", {
                    position: "top-right"
                });
            } else {
                toast.error(res?.message || "Operation failed", {
                    position: "top-right",
                    toastId: 'reject-error'
                });
            }
        } catch (error) {
           
            toast.error("Operation failed", { position: "top-right" });
        } finally {
            setIsSubmitting(false);
        }
    };

    // Helper function to get button styling based on status
    const getButtonStyle = (status: string) => {
        switch (status) {
            case 'approved':
                return 'btn btn-success px-4';
            case 'reject':
                return 'btn btn-outline-secondary px-4';
            case 'permanentReject':
                return 'btn btn-outline-danger px-4';
            default:
                return 'btn btn-primary px-4';
        }
    };

    // Helper function to get icon based on status
    const getButtonIcon = (status: string) => {
        switch (status) {
            case 'approved':
                return 'bi bi-check-circle';
            case 'reject':
                return 'bi bi-arrow-clockwise';
            case 'permanentReject':
                return 'bi bi-x-circle';
            default:
                return 'bi bi-arrow-right-circle';
        }
    };

    const handleInputChange = (field: string, value: string) => {
        setComment(value)
    }

    const pdfUrl = React.useMemo(() => {
        if (!file || file.mimeType !== "application/pdf") return null;
        try {
            const base64Data = file?.fileData.split(',')[1] || file?.fileData;
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            return URL.createObjectURL(blob);
        } catch (error) {
        
            return null;
        }
    }, [file])

    useEffect(() => {
        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        };
    }, [pdfUrl]);

    return (
        <div className="page-wrapper">
            <div className="container-fluid py-3">
                <div className="row justify-content-center">
                    <div className="col-12 col-xl-12">
                        {/* Document Viewer Card */}
                        <div className="card shadow-sm border-0" style={{ height: "calc(100vh - 85px)", display: "flex", flexDirection: "column" }}>
                            <div className="card-body p-4" style={{ flex: "1", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                                {/* Loading State */}
                                {loading && (
                                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ flex: "1" }}>
                                        <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="text-muted mb-0">Loading document...</p>
                                    </div>
                                )}

                                {/* No Document State */}
                                {pdfUrl && !loading && !file && (
                                    <div className="text-center d-flex flex-column justify-content-center align-items-center" style={{ flex: "1" }}>
                                        <i className="bi bi-file-earmark-x fs-1 text-muted mb-3 d-block"></i>
                                        <h5 className="text-muted">No document found</h5>
                                        <p className="text-muted small">The requested document could not be loaded.</p>
                                    </div>
                                )}

                                {/* Document Display */}
                                {!loading && file && pdfUrl && (
                                    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
                                        {/* File Info Badge */}
                                        <div className="mb-3 pb-3 border-bottom" style={{ flexShrink: 0 }}>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                                <div>
                                                    <span className="badge bg-light text-dark border fs-14 px-3 py-2">
                                                        <i className="bi bi-file-earmark me-2"></i>
                                                        This is the Application File Kindly Review it and make the Required Action
                                                    </span>
                                                </div>

                                                <div>
                                                    <a
                                                        href={file.fileData}
                                                        download={file.fileName}
                                                        className="btn btn-sm btn-outline-primary"
                                                    >
                                                        <i className="bi bi-download me-1"></i>
                                                        Download
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Document Content */}
                                        <div className="document-viewer" style={{ flex: "1", overflowY: "auto", overflowX: "hidden" }}>
                                            {file.mimeType?.startsWith("image/") && (
                                                <div className="text-center bg-light rounded p-3">
                                                    <img
                                                        src={file?.fileData}
                                                        alt={file?.fileName}
                                                        className="img-fluid rounded shadow-sm"
                                                        style={{ maxWidth: "100%", height: "auto" }}
                                                    />
                                                </div>
                                            )}

                                            {file?.mimeType === "application/pdf" && (
                                                <div className="border rounded overflow-hidden" style={{ height: "100%" }}>
                                                    <iframe
                                                        src={pdfUrl} //yashChangedCode.
                                                        width="100%"
                                                        height="100%"
                                                        title="PDF Viewer"
                                                        className="border-0"
                                                    />
                                                </div>
                                            )}

                                            {!file?.mimeType?.startsWith("image/") && file?.mimeType !== "application/pdf" && (
                                                <div className="alert alert-info d-flex align-items-center" role="alert">
                                                    <i className="bi bi-info-circle-fill me-2"></i>
                                                    <div>
                                                        Preview not available for this file type.
                                                        <a
                                                            href={file?.fileData}
                                                            download={file?.fileName}
                                                            className="alert-link ms-2"
                                                        >
                                                            Click here to download
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Action Buttons Footer */}
                            {!loading && file && (
                                <div className="card-footer bg-white border-top py-3">
                                    {roleIdentifier === "MBMD" && (<span className="badge bg-light text-dark border mb-3 fs-14 px-3 py-2 text-wrap text-break">
                                        <i className="bi bi-file-earmark"></i>
                                        Comment from MBA: {appComment}
                                    </span>)}
                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                                        {/* Comment textarea */}
                                        <textarea
                                            rows={2}
                                            className="border-2 rounded border-secondary w-100"
                                            placeholder="Enter Comment"
                                            onChange={(e) => handleInputChange("comment", e.target.value)}
                                            value={comment}
                                        />

                                        {/* Dynamic buttons based on role */}
                                        {appData?.buttonName && appData.buttonName.length > 0 && (
                                            <div className={`d-flex ${roleIdentifier === "MBMD" ? 'gap-2' : 'justify-content-end'} flex-shrink-0`}>
                                                {roleIdentifier === "MBA" && appData.buttonName.length === 1 ? (
                                                    // Single button for MBA
                                                    <button
                                                        className={getButtonStyle(appData.buttonName[0]?.status)}
                                                        onClick={() => handleForward(appData.buttonName[0])}
                                                    >
                                                        <i className={`${getButtonIcon(appData.buttonName[0]?.status)} me-2`}></i>
                                                        {appData.buttonName[0]?.buttonLabel}
                                                    </button>
                                                ) : roleIdentifier === "MBMD" && appData.buttonName.length >= 3 ? (
                                                    // Multiple buttons for MBMD
                                                    appData.buttonName.map((button: any, index: number) => (
                                                        <button
                                                            key={index}
                                                            className={getButtonStyle(button?.status)}
                                                            onClick={() => handleForward(button)}
                                                        >
                                                            <i className={`${getButtonIcon(button?.status)} me-2`}></i>
                                                            {button?.buttonLabel}
                                                        </button>
                                                    ))
                                                ) : null}
                                                <button
                                                    className="btn btn-link"
                                                    data-bs-target="#viewCertificate"
                                                    data-bs-toggle="modal"
                                                // onClick={() => handleForward(button)}
                                                >
                                                    View Certificate
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* //////////////VIEW CERTIFICATE/////////////////// */}
            <div className="card-body">
                <div
                    className="modal fade modal-dialog-scrollable modal-lg"
                    id="viewCertificate"
                    aria-hidden="true"
                    aria-labelledby="exampleModalToggleLabel"
                    tabIndex={-1}
                >

                    <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                        <div className="modal-content full-modal">
                            <div className="modal-header">
                                <h4
                                    className="modal-title"
                                    id="exampleModalToggleLabel"
                                >
                                    Certificate View

                                </h4>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body m-0 p-0">
                                <CertificateMD />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary me-3"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ///////////////////////////////////////// */}


            {/* Rejection Modal - Using State-based approach like MDFormL */}
            {showRejectModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }} id="rejectModal" aria-hidden="true" aria-labelledby="rejectModalLabel" tabIndex={-1}>
                        {uploadLoading && (
                            <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}>
                                <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
                                    <div className="spinner-border text-primary mb-3" role="status">
                                        <span className="visually-hidden">Uploading...</span>
                                    </div>
                                    <div className="fw-bold">Uploading, please wait...</div>
                                </div>
                            </div>
                        )}
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="rejectModalLabel">
                                        Application Rejection
                                    </h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setShowRejectModal(false);
                                            setComment("");
                                        }}
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to reject this application?</p>

                                    <input
                                        type="file"
                                        className="form-control w-100 border border-dark mb-2"
                                        name="rejectionFile"
                                        onChange={(e) => handleFileChange(e, "rejectionFile")}
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        disabled={uploadLoading}
                                    />
                                    {newlyUploaded.rejectionFile && (
                                        <p className="fs-15 mt-2 opacity-75">
                                            Uploaded: {newlyUploaded.rejectionFile?.fileName}
                                        </p>
                                    )}
                                    <p className="text-muted small">Upload File (optional)</p>

                                    <textarea
                                        className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                                        style={{ fontSize: '1.25rem' }}
                                        rows={3}
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        placeholder="Enter your remarks here. *"
                                        required
                                    />
                                    {comment.trim() === '' && (
                                        <small className="text-danger">* Remarks are required</small>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary me-3"
                                        onClick={() => {
                                            setShowRejectModal(false);
                                            setComment("");
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-danger"
                                        onClick={handlePermanentReject}
                                        disabled={uploadLoading || isSubmitting || comment.trim() === ''}
                                    >
                                        {uploadLoading ? 'Uploading...' : isSubmitting ? 'Processing...' : 'Yes, Reject Application'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {/* Success Modal */}
            {showRejectSuccessModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }} id="rejectSuccessModal" aria-hidden="true" aria-labelledby="rejectSuccessModalLabel" tabIndex={-1}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="rejectSuccessModalLabel">
                                        <i className="feather feather-check-circle text-success me-2"></i>
                                        Application Rejected
                                    </h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowRejectSuccessModal(false)}
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    Application has been rejected and status sent to the sponsor
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info me-3 w-100"
                                        onClick={() => {
                                            setShowRejectSuccessModal(false);
                                            setTimeout(() => {
                                                navigate("/marketing-board-agr-menu");
                                            }, 1000);
                                        }}
                                    >
                                        Ok
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            <ToastContainer />
        </div>
    );
};

export default PDFView;